import map from 'lodash/map'
import get from 'lodash/get'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import DnsIcon from '@mui/icons-material/Dns'
import FlexColumn from './layouts/FlexColumn'
import Flex from './layouts/Flex'

function NodeChipFilter({ nodes, activeNodeId, onSelect, pendingCountByNodeId }) {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  if (!isDesktop) {
    return (
      <Select
        value={activeNodeId || ''}
        onChange={(e) => onSelect(e.target.value)}
        fullWidth
        size="small"
      >
        {map(nodes, (node) => {
          const pendingCount = get(pendingCountByNodeId, node.id, 0)
          return (
            <MenuItem key={node.id} value={node.id}>
              <Flex gap={1} sx={{ alignItems: 'center' }}>
                <DnsIcon fontSize="small" />
                {node.name}
                {pendingCount > 0 && (
                  <Box
                    sx={{
                      bgcolor: 'pendingChanges.main',
                      color: 'pendingChanges.contrastText',
                      borderRadius: '8px',
                      minWidth: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      px: 0.5,
                    }}
                  >
                    {pendingCount}
                  </Box>
                )}
              </Flex>
            </MenuItem>
          )
        })}
      </Select>
    )
  }

  return (
    <FlexColumn gap={1}>
      {map(nodes, (node) => {
        const pendingCount = get(pendingCountByNodeId, node.id, 0)
        return (
          <Chip
            key={node.id}
            icon={<DnsIcon />}
            label={
              <Flex gap={1} sx={{ alignItems: 'center' }}>
                {node.name}
                {pendingCount > 0 && (
                  <Box
                    sx={{
                      bgcolor: 'pendingChanges.main',
                      color: 'pendingChanges.contrastText',
                      borderRadius: '8px',
                      minWidth: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      px: 0.5,
                    }}
                  >
                    {pendingCount}
                  </Box>
                )}
              </Flex>
            }
            variant={activeNodeId === node.id ? 'filled' : 'outlined'}
            color="secondary"
            onClick={() => onSelect(node.id)}
            clickable
            sx={{ justifyContent: 'flex-start', width: '100%' }}
          />
        )
      })}
    </FlexColumn>
  )
}

export default NodeChipFilter
